import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useOutlet } from 'react-router-dom';

import { HeaderLanding } from '../Header_V2';
import { FooterLanding } from '../Footer_V2';
import { useAuth } from '../../hooks/useAuth';
import { useTelemetry } from '../../hooks/useTelemetry';
import { getRoute, ROUTE_ENUMS } from '../../helpers/routes';

import { Stack } from '@mui/material';
import CookieConsentBanner from '../CookieConsentBanner';

const LandingLayout = () => {
	const outlet = useOutlet();
	const navigate = useNavigate();
	const { authStep, checkAuthStatus, isAuthenticated } = useAuth();
	const { consentStatus, handleConsentChange } = useTelemetry();

	useEffect(() => {
		checkAuthStatus();
	}, []);

	useEffect(() => {
		if (authStep === null && isAuthenticated) {
			navigate(getRoute(ROUTE_ENUMS.DASHBOARD), { replace: true });
		}

		if (authStep === null && !isAuthenticated) {
			navigate(getRoute(ROUTE_ENUMS.LOGIN), { replace: true });
		}
	}, [authStep, isAuthenticated]);

	return (
		<Stack display="flex" height="100vh">
			<Stack flex={1}>
				<HeaderLanding />
				{outlet}
			</Stack>
			<CookieConsentBanner
				onConsentChange={handleConsentChange}
				currentStatus={consentStatus}
			/>
			<FooterLanding />
		</Stack>
	);
};

LandingLayout.propTypes = {};

export default LandingLayout;
